import CanvasApiError from '@/hooks/canvas/helpers/CanvasApiError';
import type { GetCanvasErrorMessageParams } from '../types';

// Human copy for the domain error codes the canvas API returns. Unknown codes
// (and non-CanvasApiError throwables) fall back to the caller's context phrase
// so a raw 500 body or network blip never reaches the user.
const CANVAS_ERROR_COPY: Record<string, string> = {
    CANVAS_LIMIT_EXCEEDED: 'This canvas is full. Remove some items before adding more.',
    CANVAS_ACCESS_DENIED: "You don't have permission to do that.",
    CANVAS_NOT_FOUND: 'That canvas no longer exists.',
    CANVAS_CONNECTION_INVALID: "That connection isn't valid.",
    CANVAS_ASSET_INVALID: "That file isn't a supported canvas asset.",
    VALIDATION_ERROR: 'Some details are invalid. Please review and try again.',
};

// Single mapping every canvas toast/inline error routes through, so known codes
// read consistently and unknowns degrade to a safe fallback.
const getCanvasErrorMessage = ({ error, fallback }: GetCanvasErrorMessageParams): string => {
    if (error instanceof CanvasApiError) {
        return CANVAS_ERROR_COPY[error.code] ?? fallback;
    }
    return fallback;
};

export default getCanvasErrorMessage;
